import { Location } from '@angular/common';

import { ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { Router } from '@angular/router';

import { AudioRecordingService } from 'src/app/Service/audio-recording.service';

import { DomSanitizer } from '@angular/platform-browser';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'app-buffet',

  templateUrl: './buffet.component.html',

  styleUrls: ['./buffet.component.css']

})

export class BuffetComponent implements OnInit {

  list_Buffet: any = [];

  list_Search: any = [];

  model: any = {};

  editMode: boolean = false;

  isLoading: boolean = false;

  bChanged: boolean = false;

  constructor(

    private location: Location,

    private formBuilder: FormBuilder,

    private Notification: NotificationService,

    private router: Router,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.getBuffets()

  }

  async getBuffets() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`Buffet_List`, model)).data.toString());

    this.list_Buffet = res;

    this.list_Search = res;

    this.isLoading = false;

  }

  async deleteBuffet(item: any) {

    $.confirm({

      title: `آیا از حذف این محصول اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this.isLoading = true;

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iBuffet: item.iBuffet
            }

            let res = JSON.parse((await axios.post(`Buffet_Delete`, model)).data.toString());

            this.isLoading = false;

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('محصول با موفقیت حذف شد');

              const index = this.list_Buffet.indexOf(item);

              if (index != -1) this.list_Buffet.splice(index, 1)

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async newProduct() {

    if (!this.model.strTitle || !this.model.iPrice || !this.model.strImage) return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    this.model.iPrice = this.model.iPrice.toString().replace(/,/g, '');

    this.model.iPrice = this.model.iPrice.toString().replace(/ تومان /g, '');

    this.model.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

    this.model.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);

    this.model.bActive = !this.model.bActive ? false : this.model.bActive;


    if (!this.editMode) {

      this.isLoading = true;

      let res = JSON.parse((await axios.post(`Buffet_Save`, this.model)).data.toString());

      this.isLoading = false;

      this.list_Buffet.push(res[0])

      this.Notification.showSuccess('با موفقیت ثبت شد');

      this.model = {};

      $(`#newProduct`).modal('hide');


    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this.isLoading = true;

              let res = JSON.parse((await axios.post(`Buffet_Edit`, this.model)).data.toString())[0];

              const index = this.list_Buffet.indexOf(this.model);

              if (index != -1) this.list_Buffet[index] = res;

              this.Notification.showSuccess('با موفقیت ویرایش شد');

              this.model = {}

              $(`#newProduct`).modal('hide');

              this.isLoading = false;

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });
    }


  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Buffet = this.list_Search.filter((el: any) => {

        return el.strTitle.includes(search)

      })
    }

    else if (search == '') this.list_Buffet = this.list_Search;

  }

  openModal(id: string) {

    $(`#${id}`).modal('show');

  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.Notification.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.model.strImage = base64String;

        this.model.strImage = this.model.strImage.replace('data:image/jpeg;base64,', '');

      };

    }


  }

  editBuffet(item: any) {

    this.model = item;

    this.editMode = true;

    this.openModal('newProduct')
  }

  goBack() {

    this.router.navigate(['/'])
  }

  handleChange(): void { if (this.editMode) this.bChanged = true; }
  

  closeModal() {

    if (this.editMode && this.bChanged) this.getBuffets();

    this.model = {};

    this.editMode = false;

    this.bChanged = false;


  }

}
